import { render, staticRenderFns } from "./SupplierCompanyCreateEdit.vue?vue&type=template&id=137368cd&scoped=true&"
import script from "./SupplierCompanyCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SupplierCompanyCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCompanyCreateEdit.vue?vue&type=style&index=0&id=137368cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137368cd",
  null
  
)

export default component.exports